import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "file-preview"
};
var _hoisted_2 = {
  key: 0,
  class: "loading"
};
var _hoisted_3 = ["src"];
import { ref, watch, onMounted, onUnmounted, nextTick } from 'vue';
import { encode } from 'js-base64';
var previewPrefix = 'https://filepreview.zhixuehuijiao.cn/onlinePreview?url=';
export default {
  __name: 'Preview',
  props: {
    path: {
      type: String,
      default: ''
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var showPath = ref('');
    var loading = ref(true);
    var iframeRef = ref(null);
    watch(function () {
      return props.path;
    }, function (val) {
      if (val) {
        var code = encodeURIComponent(encode(val));
        showPath.value = previewPrefix + code;
        nextTick(function () {
          iframeInit();
        });
      }
    }, {
      immediate: true
    });
    onMounted(function () {
      window.addEventListener('resize', iframeInit, false);
    });
    onUnmounted(function () {
      window.removeEventListener('resize', iframeInit, false);
    });
    var showLoading = function showLoading() {
      loading.value = true;
    };
    var hideLoading = function hideLoading() {
      loading.value = false;
    };
    var iframeInit = function iframeInit() {
      nextTick(function () {
        showLoading();
        if (iframeRef.value) {
          if (iframeRef.value.attachEvent) {
            iframeRef.value.attachEvent('onload', function () {
              return hideLoading();
            });
          } else {
            iframeRef.value.onload = function () {
              return hideLoading();
            };
          }
        }
      });
    };
    return function (_ctx, _cache) {
      var _component_t_loading = _resolveComponent("t-loading");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [!showPath.value && loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_t_loading, {
        text: "文件加载中..."
      })])) : _createCommentVNode("", true), showPath.value ? (_openBlock(), _createElementBlock("iframe", {
        key: 1,
        ref_key: "iframeRef",
        ref: iframeRef,
        allowfullscreen: true,
        src: showPath.value,
        class: "iframe"
      }, null, 8, _hoisted_3)) : _createCommentVNode("", true)]);
    };
  }
};